import styled from 'styled-components';

const FiltersBar = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  grid-column-gap: 0.375rem;
  grid-row-gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0 1rem;
  font-size: 0.875rem;

  &:empty {
    display: none;
  }
`;

export default FiltersBar;
